export enum InvoiceIssueTypeDetail {
    WRONG_PRICE_BILLED = 'Wrong Price Billed',
    WRONG_SOLD_TO_ACCOUNT_NUMBER = 'Wrong Sold-to Account Number',
    WRONG_SHIP_TO_ACCOUNT_NUMBER = 'Wrong Ship-to Account Number',
    WRONG_BILL_TO_ACCOUNT_NUMBER = 'Wrong Bill-to Account Number',
    BILLED_AND_SHOULD_BE_FOC = 'Billed and should be FOC',
    FOC_AND_SHOULD_BE_BILLED = 'FOC and should be billed',
    PAYMENT_TERMS = 'Payment Terms',
    CREDIT_HOLD = 'Credit Hold'
}
